module.exports = __webpack_public_path__ + "901ec9adf370441662bfc1f955336c99.svg";